module.exports = __webpack_public_path__ + "static/media/activity-content-four.8210f06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/activity/components/images/activity-content-four.png
// module id = 910
// module chunks = 0